// @ts-nocheck
import React, {/*useState*/ } from "react";
import { useQuery, useQueryClient } from "react-query";

import PostTile from "../../Pages/Posts/components/Tile/PostTile";
import genRequest from "includes/request";
import { fetchPostCategories } from "classes/Posts/postCategories";
import { postUnreadKey } from "classes/Posts/postUnreadKey";
import useAccount from "classes/Accounts/hooks/useAccount";
import useUnread from "classes/Accounts/hooks/useUnread";
import { useMediaQuery } from "react-responsive";

export default function Post(props) {
	const isMobile = useMediaQuery({ query: '(max-width: 700px)' });

	const { account } = useAccount();
	const { isReaded, setAsReaded } = useUnread();
	const QCL = useQueryClient();
	// const [hasResponse, setHasResponse] = useState(false);
	let PostId = props.datas?.id;
	let EmployeeId = props.datas?.employeeId;
	let PostTypeId = props.datas?.postTypeId;
	let isPostReaded = isReaded(postUnreadKey(PostTypeId), PostId);

	// const retrieveResponse = async () => {

	// 	let req = await genRequest("posts/" + PostId + "/news-responses")
	// 	.then((resp) => {
	// 		setHasResponse(resp);
	// 		return (resp);
	// 	}).catch((e) => {
	// 		setHasResponse(false);
	// 	})
	// 	return (req);
	// }

	const retrieveCategories = () => fetchPostCategories(PostId);

	const incrementViews = () => {
		// Don't skip the API call when the viewer is also the post's
		// author. The original guard
		//   if (EmployeeId && account.employeeId === EmployeeId && isPostReaded)
		//     return Promise.resolve(true);
		// was meant to avoid double-counting an author re-reading their own
		// post — but it also stopped writing the per-employee view row,
		// so the badge query (which counts posts NOT in employee_view_posts)
		// kept reporting the author's own post as unviewed forever.
		// Backend is idempotent on the upsert, and view_count is only bumped
		// when the row is newly inserted, so re-clicks are harmless.
		let req = genRequest(
			"posts/" + PostId + "/view",
			null,
			"post"
		).then((resp) => {
			return (resp);
		}).catch((err) => {
			// Surface the failure instead of swallowing — the previous
			// silent catch is exactly what hid the "post_type_id" /
			// "is_viewed" insert failures and made the badge bug invisible
			// to diagnose. Keep the promise resolved so the caller's chain
			// still fires (setAsReaded etc.), but log so devs can see.
			// eslint-disable-next-line no-console
			console.error("[incrementViews] POST posts/" + PostId + "/view failed", err);
		});
		return (req);
	};

	function handleClick() {
		if (!props.isActive || props.isFirstDisplayed) {
			// Always hit the API on click — the backend is idempotent
			// (ON CONFLICT) and we cannot trust sessionStorage's "already
			// read" flag: it was set true by older builds even when the
			// DB insert silently failed (post_type_id was NULL, so the
			// badge SQL never saw the row). For users carrying that
			// stale local state, gating the call on !isPostReaded meant
			// the API was never retried after the backend fix shipped.
			incrementViews().then(() => {
				setAsReaded(postUnreadKey(PostTypeId), PostId);
				QCL.invalidateQueries([
					"NotViewed",
					"Me",
					"not-viewed-posts",
					PostTypeId?.toString(),
				]);
			});
		}
		if (props.onClick)
			props.onClick(this);
	}

	let post = props.datas;

	const { isLoading, data } = useQuery(
		["Categories", "Post", PostId],
		retrieveCategories
	);

	if (props.dispCats?.length) {
		let cats = data;
		if (!cats?.length)
			return (false);
		let check = false;
		for (let x in cats)
			if (props.dispCats.indexOf(cats[x].id) !== -1)
				check = true;
		if (!check)
			return (false);
	}

	if (props.childComponent)
		return (
			<props.childComponent
				companyId={account?.companyId}
				direction={props.direction}
				isFirstDisplayed={props.isFirstDisplayed}
				isActive={props.isActive}
				datas={post}
				dispImages={props.dispImages}
				// hasResponse={hasResponse}
				onClick={handleClick}
				isLoading={isLoading}
			/>
		);
	return (
		<PostTile
			isMobile={isMobile}
			companyId={account?.companyId}
			direction={props.direction}
			isFirstDisplayed={props.isFirstDisplayed}
			isActive={props.isActive}
			isReaded={isPostReaded}
			datas={post}
			dispImages={props.dispImages}
			// hasResponse={hasResponse}
			onClick={handleClick}
			isLoading={isLoading}
		/>
	);
}
